/* eslint-disable eqeqeq */
/* eslint-disable no-else-return */
import { Icon } from '@iconify/react';
// import PersonIcon from '@mui/icons-material/Person';
import { PATH_DASHBOARD } from '../../../routes/paths';
import SvgIconStyle from '../../../components/SvgIconStyle';

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
};

const getNavConfig = (userRole) => {
  if (userRole) {
    return [
      {
        items: [
          { title: 'Dashboard', path: '/dashboard/home', icon: <Icon icon="ri:dashboard-line" /> },
          { title: 'Currency', path: PATH_DASHBOARD.currency.currency, icon: ICONS.banking },
          { title: 'Price', path: PATH_DASHBOARD.price.price, icon: ICONS.analytics },
          { title: 'Organization', path: PATH_DASHBOARD.organization.organization, icon: ICONS.booking },
          { title: 'Donation', path: PATH_DASHBOARD.donation.donation, icon: ICONS.dashboard },
        ],
      },
    ];
  } else {
    return [];
  }
};

export default getNavConfig;
